/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import validatePhone from "@insite/client-framework/Common/Utilities/validatePhone";
import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    AddressErrors,
    chain,
    ValidateEmail,
    ValidateFax,
    ValidatePhone,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    AddressFieldDisplayCollectionModel,
    AddressFieldDisplayModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";


const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;

export const XngValidatePhone: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { phone } = props.parameter.address;
    if (addressFieldDisplayCollection.phone?.isVisible && validationRules.phone?.isRequired && isEmpty(phone)) {
        props.addressErrors.phone = getRequiredErrorMessage(addressFieldDisplayCollection.phone);
    } else if (!isEmpty(phone) && !validatePhone(phone) && addressFieldDisplayCollection.phone?.isVisible) {
        props.addressErrors.phone = siteMessage("AddressInfo_Phone_Validation");
    }
};

export const XngValidateEmail: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { email } = props.parameter.address;
    if (addressFieldDisplayCollection.email?.isVisible && validationRules.email?.isRequired && isEmpty(email)) {
        props.addressErrors.email = getRequiredErrorMessage(addressFieldDisplayCollection.email);
    } else if (!isEmpty(email) && !validateEmail(email) && addressFieldDisplayCollection.email?.isVisible) {
        props.addressErrors.email = siteMessage("AddressInfo_EmailAddress_Validation");
    }
};

export const XngValidateFax: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { fax } = props.parameter.address;
    if (addressFieldDisplayCollection.fax?.isVisible && validationRules.fax?.isRequired && isEmpty(fax)) {
        props.addressErrors.fax = getRequiredErrorMessage(addressFieldDisplayCollection.fax);
    } else if (!isEmpty(fax) && !validatePhone(fax) && addressFieldDisplayCollection.fax?.isVisible) {
        props.addressErrors.fax = siteMessage("AddressInfo_Phone_Validation");
    }
};

replaceInChain(chain, ValidatePhone, XngValidatePhone);
replaceInChain(chain, ValidateEmail, XngValidateEmail);
replaceInChain(chain, ValidateFax, XngValidateFax);
